import { connect } from 'react-redux';
import { goToAdd } from '../ManageServices.saga';
import EmptyList from './EmptyList';

const mapDispatchToProps = {
  handleAddClick: goToAdd,
};

export default connect(null, mapDispatchToProps)(EmptyList);
